if (!customElements.get('spring-tab-products')) {
    class SpringTabProducts extends HTMLElement {
        constructor() {
            super();
            this._tabList = this.querySelectorAll('.tab-item');
            this._tabContents = this.querySelectorAll('.spring-tab__content');
            this._currentTab = '';
            this.initTab();
        }

        initTab() {
            this._tabContents.forEach(tabContent => {
                let target = tabContent.dataset.target;
                let currentTab = this.querySelector(`.tab-item[data-target="${target}"]`);
                let startDate = new Date(tabContent.dataset.startDate);
                let endDate = new Date(tabContent.dataset.endDate);
                let startDateStr = tabContent.dataset.startDateStr;
                let endDateStr = tabContent.dataset.endDateStr;
                let currentLocale = tabContent.dataset.locale;

                let dateStr = startDateStr + ' - ' + endDateStr;
                let date = new Date();
                let currentDateStr = new Intl.DateTimeFormat(currentLocale, { year: '2-digit', month: '2-digit', day: '2-digit' }).format(date);
                let currentDate = new Date(currentDateStr);
                if(date >= startDate) {
                    this._currentTab = target;
                }
                currentTab.querySelector('.tab-date-range').innerHTML = dateStr;
            });

            this._tabList.forEach(tab => {
                tab.addEventListener('click',() => {
                    let target = tab.dataset.target;
                    this.activeTab(target);
                })
            })

            console.log('ccc:',this._currentTab)
            this.activeTab(this._currentTab);
        }

        activeTab(target) {
            if(target == '') {
                target = this._tabContents[0].dataset.target;
            }

            let currentTabContent = null;
            let currentTab = null;

            if(this._currentTab != '') {
                currentTabContent = this.querySelector(`.spring-tab__content[data-target="${this._currentTab}"]`);
                currentTab = this.querySelector(`.tab-item[data-target="${this._currentTab}"]`);
                currentTab.classList.remove('active');
                currentTabContent.classList.remove('active');
            }
            this._currentTab = target;
            currentTabContent = this.querySelector(`.spring-tab__content[data-target="${this._currentTab}"]`);
            currentTab = this.querySelector(`.tab-item[data-target="${this._currentTab}"]`);
            currentTab.classList.add('active');
            currentTabContent.classList.add('active');
        }

        formatDate(date,currentLocale) {
            
            return date.toLocaleDateString(currentLocale, { month: 'short', day: 'numeric' });
            
        }
        
    }

    customElements.define('spring-tab-products', SpringTabProducts);
}